// Firebase Analytics (GA4) for the web app — the browser half of the mobile
// app's `@react-native-firebase/analytics` mirror.
//
// Same Firebase project as the mobile app (tarbaa-c23f6), through the **Web
// app** registered inside it — so web GA4 events land next to the app's.
// The config below is the console-generated one; REACT_APP_FIREBASE_* env vars
// override it. These values are public by design (they identify the project,
// they don't authorize anything).
//
// If appId/measurementId are ever blanked the whole Firebase mirror no-ops;
// the backend batch pipeline in ./index.js keeps working regardless.

const FIREBASE_CONFIG = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyAsz5pIgX98QBnu0UbFgYlzzt0ge2LiuwY",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tarbaa-c23f6.firebaseapp.com",
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    "https://tarbaa-c23f6-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tarbaa-c23f6",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "tarbaa-c23f6.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "245606340972",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:245606340972:web:a21e69a2af0a2f614f3b49",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-HY0EKMD9RV",
};

export const isFirebaseConfigured = !!(
  FIREBASE_CONFIG.apiKey &&
  FIREBASE_CONFIG.appId &&
  FIREBASE_CONFIG.measurementId
);

// Calls made before init resolves are buffered here, then replayed in order.
// Analytics init is async (isSupported() probes for cookies/indexedDB), and
// the first page view fires well before it settles.
let analytics = null;
let fb = null; // lazily-imported firebase/analytics module handle
let pending = [];

const run = (fn) => {
  if (analytics) {
    try {
      fn(analytics);
    } catch (_) {
      // analytics must never break the page
    }
    return;
  }
  if (pending.length < 100) pending.push(fn);
};

async function init() {
  if (!isFirebaseConfigured) return;
  try {
    const [{ initializeApp, getApps }, analyticsMod] = await Promise.all([
      import("firebase/app"),
      import("firebase/analytics"),
    ]);
    const supported = await analyticsMod.isSupported();
    // Unsupported = private mode / no cookies / SSR-ish env. Not an error.
    if (!supported) {
      pending = [];
      return;
    }
    const app = getApps().length
      ? getApps()[0]
      : initializeApp(FIREBASE_CONFIG);
    analytics = analyticsMod.getAnalytics(app);
    fb = analyticsMod;
    const queued = pending;
    pending = [];
    queued.forEach((fn) => {
      try {
        fn(analytics);
      } catch (_) {}
    });
  } catch (error) {
    pending = [];
    if (process.env.NODE_ENV === "development") {
      console.warn("[analytics] firebase init failed:", error);
    }
  }
}

init();

export function logFirebaseEvent(name, params) {
  run(() => fb.logEvent(analytics, name, params));
}

export function logFirebaseScreenView(screenName) {
  run(() =>
    fb.logEvent(analytics, "screen_view", {
      screen_name: screenName,
      screen_class: screenName,
    }),
  );
}

export function setFirebaseUserId(userId) {
  run(() => fb.setUserId(analytics, userId ? String(userId) : null));
}

export function setFirebaseUserProperties(props) {
  run(() => fb.setUserProperties(analytics, props));
}
